<script setup>
import { computed, ref } from 'vue'
import { useI18n } from "vue-i18n";
import Map from '@/components/map/map.vue'

const props = defineProps({
  serviceProvider: {
    type: Object,
    required: true
  }
})

// I18n
const { t } = useI18n();

// Carousel state
const currentIndex = ref(0)

// Compute carousel items (only gallery images now)
const carouselItems = computed(() => {
  const items = []
  
  if (props.serviceProvider.sponsored_scope_tier > 1 && props.serviceProvider.gallery_images_urls) {
    props.serviceProvider.gallery_images_urls.forEach(url => {
      items.push({ type: 'image', url })
    })
  }
  
  return items
})

const totalItems = computed(() => carouselItems.value.length)

const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % totalItems.value
}

const prevSlide = () => {
  currentIndex.value = (currentIndex.value - 1 + totalItems.value) % totalItems.value
}

</script>

<template>
  <div class="w-full md:max-w-[600px] shrink-0 relative">
    <div class="flex items-center gap-4">
      <!-- Left arrow -->
      <button v-if="totalItems > 1" @click="prevSlide" class="bg-black/50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/70 shrink-0">
        ‹
      </button>
      
      <!-- Image container -->
      <div class="h-[375px] border rounded-xl overflow-hidden shadow-2xl relative flex-1" style="background-color: #fbf5e9;">
        <!-- Current item -->
        <div v-for="(item, index) in carouselItems" :key="index" v-show="index === currentIndex" class="h-full w-full">
          <img :src="item.url" class="h-full w-full object-contain" :alt="`Gallery image ${index + 1}`">
        </div>
        
        <!-- Floating black bar -->
        <div class="absolute bottom-0 left-0 w-full h-[36px] bg-black text-white flex justify-center items-center z-20">
          <p class="tracking-[0.5em]">{{ currentIndex + 1 }}/{{ totalItems }}</p>
        </div>
      </div>
      
      <!-- Right arrow -->
      <button v-if="totalItems > 1" @click="nextSlide" class="bg-black/50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/70 shrink-0">
        ›
      </button>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/main';

.loading-placeholder {
  background-color: rgb(from $header-light r g b / 40%)
}
</style>
